import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BasicTextArea, BaasicFieldDropdown } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function MissingDocumentEditTemplate({ editView }) {
    const {
        contentLoading,
        form,
        itemCategoryStore
    } = editView;

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicTextArea field={form.$('note')} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
									<BaasicFieldDropdown field={form.$('itemCategoryId')} store={itemCategoryStore} allowEmpty={true}/>
								</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

MissingDocumentEditTemplate.propTypes = {
    editView: PropTypes.object
};

export default defaultTemplate(MissingDocumentEditTemplate);
